import {IComponentOptions} from 'angular';
import './dv-benutzerprofil.scss';
import TSBenutzer from '../../../models/TSBenutzer';
import {getTSAnredeValues, TSAnrede} from '../../../models/enums/TSAnrede';
import {getTSSpracheValues, TSSprache} from '../../../models/enums/TSSprache';
import IScope = angular.IScope;

let template = require('./dv-benutzerprofil.html');

export class DVBenutzerprofilComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        benutzer: '=',
        readonly: '<',
        hidePasswordEntry: '<',
        doubleEmailEntry: '<',
        pwChangeWithButton: '<',
        onChangePassword: '&',
        noEmailEntry: '<',
        phoneRequired: '<',

    };
    template = template;
    controller = DVBenutzerprofilController;
    controllerAs = 'vm';
    bindToController = true;
}

export class DVBenutzerprofilController {
    benutzer: TSBenutzer;
    readonly: boolean;
    hidePasswordEntry: boolean;
    doubleEmailEntry: boolean;
    pwChangerEmailVisible: boolean;
    pwChangeWithButton: boolean;
    pressedChangePassword: boolean = false;
    onChangePassword: (paramObj: any) => void;
    noEmailEntry: boolean = false;
    phoneRequired: boolean = false;
    pattern: string = this.CONSTANTS.PATTERN_PHONE_OPTIONAL;

    static $inject: string[] = ['$scope', 'CONSTANTS'];

    constructor(private $scope: IScope, private CONSTANTS: any) {

    }

    $onInit() {
        if (this.benutzer && this.benutzer.passwordData) {
            this.$scope.$watch(() => {
                return this.benutzer.passwordData.email
            }, () => {
                if (this.benutzer.passwordData.email) {
                    this.benutzer.email = this.benutzer.passwordData.email;
                } else {
                    this.benutzer.email = '';
                }
            })
        }
        if (this.readonly === undefined) {
            this.readonly = false;
        }

        if (this.hidePasswordEntry === undefined) {
            this.hidePasswordEntry = false;
        }

        if (this.doubleEmailEntry === undefined) {
            this.doubleEmailEntry = false;
        }

        if (this.pwChangeWithButton === undefined) {
            this.pwChangeWithButton = false;
        }
        if (this.noEmailEntry === undefined) {
            this.noEmailEntry = false;
        }
        this.pwChangerEmailVisible = !this.doubleEmailEntry; //wenn wir email schon zweimal eingeben lassen dann brauchts das nicht mehr
        //if user was already sotred we are in edit mode, so we can set the repetition email to the current value
        if (this.benutzer && !this.benutzer.isNew()) {
            this.benutzer.emailRepeat = this.benutzer.email;
        }

        if (this.phoneRequired === undefined) {
            this.phoneRequired = false;
        }

    }

    private getTSAnredeValues(): Array<TSAnrede> {
        return getTSAnredeValues();
    }

    private getModel(): TSBenutzer {
        return this.benutzer;
    }

    private getTSSpracheValues(): Array<TSSprache> {
        return getTSSpracheValues();
    }

    private changePassword(event: any) {
        this.pressedChangePassword = true;
        this.onChangePassword({event: event})
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-benutzerprofil/dv-benutzerprofil.ts